import React, {CSSProperties, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {ConfirmModal} from '../../../_ancientLibrary/utilities'

type Props = {
  className?: string
  confirmActionMessage?: string
  disabled?: boolean
  displayText?: string
  icon?: any
  isFormSubmit?: boolean
  labelBump?: boolean
  margin?: string
  onClick?: any
  style?: string
  cssStyle?: CSSProperties
  submitting?: boolean
  submittingMessage?: string
}

export const AncientButton: React.FC<Props> = ({
  className,
  confirmActionMessage,
  disabled,
  displayText,
  icon,
  isFormSubmit,
  labelBump,
  margin,
  onClick,
  style,
  cssStyle,
  submitting,
  submittingMessage,
}) => {
  const [displayConfirmModal, setDisplayConfirmModal] = useState<boolean>(false)

  const onClickHandler = () => {
    if (confirmActionMessage != undefined) {
      //Display a confirmation modal before the user is able to continue.
      setDisplayConfirmModal(true)
    } else {
      if (onClick != undefined) onClick()
    }
  }
  const confirmedOnClick = () => {
    onClick()
  }

  const buttonRegular = () => {
    return (
      <>
        {labelBump ? (
          <>
            <label className='form-label'>&nbsp;</label>
            <br />
          </>
        ) : null}

        <button
          type={isFormSubmit ? 'submit' : 'button'}
          className={
            'btn ' +
            (margin != undefined ? margin : 'mx-2') +
            ' ' +
            (className != undefined ? className : 'btn-primary')
          }
          style={cssStyle}
          onClick={() => {
            onClickHandler()
          }}
          disabled={submitting || disabled}
        >
          <KTSVG path={icon} className='svg-icon-2' />
          {displayText != undefined ? displayText : null}
        </button>
        {submitting && (
          <span className='indicator-progress text-primary' style={{display: 'block'}}>
            {submittingMessage ? submittingMessage : 'Please wait...'}{' '}
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        )}
      </>
    )
  }
  const buttonRow = () => {
    return (
      <>
        <button
          type={isFormSubmit ? 'submit' : 'button'}
          className={'btn mx-2 btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'}
          onClick={() => {
            onClickHandler()
          }}
          style={cssStyle}
          disabled={disabled}
        >
          {<KTSVG path={icon} className='svg-icon-3' />}
          {submitting && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </>
    )
  }
  const buttonLink = () => {
    return (
      <>
        <button type='button' className='btn btn-link' onClick={onClick} style={cssStyle}>
          {displayText}
          {submitting && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </>
    )
  }

  const renderStyle = () => {
    switch (style) {
      case 'Link':
        return buttonLink()
      case 'Row':
        return buttonRow()
      default:
        return buttonRegular()
    }
  }

  return (
    <>
      {renderStyle()}
      {displayConfirmModal ? (
        <ConfirmModal
          onClose={setDisplayConfirmModal}
          title='Pending Delete'
          message={confirmActionMessage}
          onOk={() => {
            confirmedOnClick()
          }}
        />
      ) : null}
    </>
  )
}
